import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    systemLogContainer: css({
        boxSizing: "border-box",
        padding: 24,
        width: "100%",
        height: 260,
        backgroundColor: Color.neutral[400],
        position: "relative"
    }),
    systemLogListContainer: css({
        marginTop: 16,
        height: 170,
        maxHeight: 170,
        overflowY: "scroll",
        overflowX: "hidden"
    }),
    systemLogList: css({
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
        height: 40
    }),
    noMessageWrapper: css({
        backgroundColor: "rgba(0, 0, 0, 0)",
        width: "100%",
        height: "100%"
    }),
    noMessageIcon: css({
        fontSize: "90px !important",
        width: "90px !important",
        height: "90px !important",
        color: "white !important",
        "& svg": {
            color: "white !important",
        }
    }),
    noMessageContent: css({
        color: "white",
        textAlign: "center",
        marginTop: "10px",
        fontSize: "16px",
        fontWeight: 500
    })
});
